var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'ipub-textarea ' + _vm.ipubClass},[_c('textarea',{class:['ipub-textarea__textarea data-hj-allow'],attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"cols":_vm.autoSize.cols,"rows":_vm.autoSize.rows},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur}})])
}
var staticRenderFns = []

export { render, staticRenderFns }